var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCroosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FF5100",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12229 8.1301C8.2057 8.04679 8.31876 8 8.43665 8C8.55453 8 8.6676 8.04679 8.75101 8.1301L15.8686 15.2477C15.9124 15.2885 15.9474 15.3376 15.9717 15.3921C15.996 15.4467 16.0091 15.5056 16.0102 15.5653C16.0112 15.6251 16.0002 15.6844 15.9779 15.7398C15.9555 15.7952 15.9222 15.8455 15.8799 15.8878C15.8377 15.93 15.7874 15.9633 15.732 15.9857C15.6766 16.008 15.6173 16.019 15.5575 16.018C15.4978 16.0169 15.4389 16.0039 15.3843 15.9795C15.3298 15.9552 15.2806 15.9202 15.2399 15.8765L8.12229 8.75882C8.03898 8.67541 7.99219 8.56235 7.99219 8.44446C7.99219 8.32657 8.03898 8.21351 8.12229 8.1301Z",
    fill: "#FF5100",
    stroke: "#FF5100",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8687 8.1301C15.952 8.21351 15.9988 8.32657 15.9988 8.44446C15.9988 8.56235 15.952 8.67541 15.8687 8.75882L8.75105 15.8765C8.66672 15.955 8.55518 15.9978 8.43993 15.9958C8.32469 15.9938 8.21473 15.9471 8.13322 15.8656C8.05172 15.7841 8.00503 15.6741 8.003 15.5588C8.00097 15.4436 8.04374 15.3321 8.12232 15.2477L15.24 8.1301C15.3234 8.04679 15.4364 8 15.5543 8C15.6722 8 15.7853 8.04679 15.8687 8.1301Z",
    fill: "#FF5100",
    stroke: "#FF5100",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroosIcon);
export default __webpack_public_path__ + "static/media/croosIcon.51572b59a9d6281f07419e3637c1e8fa.svg";
export { ForwardRef as ReactComponent };